import type { LaunchPromoConfig } from '@/lib/payments/pricing-fetcher';
import type { ServerPlan } from '@/types/pricing';
import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

interface PricingState {
  plans: ServerPlan[];
  launchPromo: LaunchPromoConfig;
  isInitialized: boolean;
}

const initialState: PricingState = {
  plans: [],
  launchPromo: { active: false, plans: {} },
  isInitialized: false,
};

const pricingSlice = createSlice({
  name: 'pricing',
  initialState,
  reducers: {
    setPlans: (state, action: PayloadAction<ServerPlan[]>) => {
      state.plans = action.payload;
      state.isInitialized = true;
    },
    setLaunchPromo: (state, action: PayloadAction<LaunchPromoConfig>) => {
      state.launchPromo = action.payload;
    },
  },
});

export const { setPlans, setLaunchPromo } = pricingSlice.actions;
export default pricingSlice.reducer;
